import script from "./IssueReportEmailModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./IssueReportEmailModal.vue?vue&type=script&lang=ts&setup=true"

import "./IssueReportEmailModal.vue?vue&type=style&index=0&id=4d7afffd&lang=scss"

const __exports__ = script;

export default __exports__